<template>
  <v-progress-linear
      color="green"
      height="15"
      :value="getProgress"
      striped
  >
    <strong class="grey--text text--darken-2">{{ $t('delivery.states.'+order.state)}}</strong>
  </v-progress-linear>

</template>

<script>


import {
  DELIVERED,
  NEW,
  ON_THE_WAY,
  PENDING_RECEIPT,
  PREPARING,
  READY,
  REVIEW
} from "@/modules/delivery/constants/OrderStates";

export default {
  name: "OrderProgress",
  props:{
    order: {
      type: Object,
      required: true
    }
  },
  computed:{
    getProgress(){
      switch (this.order.state){
        case PENDING_RECEIPT:
          return 10
        case REVIEW:
          return 15
        case NEW:
          return 30
        case PREPARING:
            return 50
        case READY:
            return 80
        case ON_THE_WAY:
            return 90
        case DELIVERED:
          return 100
        default:
            return 0
      }
    }
  }
}
</script>

<style scoped>

</style>
